import { formatName } from '../../libs/localization'
import { convertDateForBody } from '../../libs/time'
import { Exam } from '../../model/exam'

export const getPatientData = (exam: Exam) => {
	const fhirPatientId =
		exam.internalPatient.externalIds?.find(
			externalId => externalId.source === 'FHIR',
		)?.code ||
		exam.fhirIdentifiers?.fhirPatientId ||
		''

	return {
		fullname: formatName(exam.internalPatient),
		birthDate: exam.internalPatient.birthDate
			? convertDateForBody(new Date(exam.internalPatient.birthDate))
			: undefined,
		email: exam.internalPatient.email || '',
		fhirPatientId,
		fhirOrganizationId: exam.externalAppointment.patient.organizationId,
	}
}
